import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { useDocument } from '../../context/documentInfoContex';
import './SavingStatus.css';

const Dot = ({ saving }) => (
    <span className={`saving-status__dot ${saving ? 'saving-status__dot--saving' : 'saving-status__dot--saved'}`} aria-hidden="true" />
);

const Line = ({ saving, label, details }) => (
    <span className="saving-status__text">
        <Dot saving={saving} />
        <span className="saving-status__label">
            {label}
            {details && <span className="saving-status__details"> &middot; {details}</span>}
        </span>
    </span>
);

/**
 * Status line under the title: a dot (amber while saving, green once saved)
 * and 12px muted text. On phones only the dot shows; the tooltip always
 * carries the full line. A hidden copy of the saved line keeps the width
 * steady while "Saving..." shows, so the tools beside it do not jump.
 */
const SavingStatus = () => {
    const { savingData } = useDocument();
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!savingData) return <div className="saving-status" />;

    const { isSaving, lastSavedDateTime, fileSize } = savingData;
    const saving = isSaving === 'Saving...';
    const details = lastSavedDateTime ? `${lastSavedDateTime}, ${fileSize}` : (fileSize || 'Board');
    const line = saving ? 'Saving your changes to Board' : `Saved to Board · ${details}`;

    return (
        <div className="saving-status">
            <Tooltip title={line}>
                <span className="saving-status__current" aria-label={line}>
                    {saving ? (
                        <Line saving label="Saving..." />
                    ) : (
                        <Line label={isSmallScreen ? '' : 'Saved to Board'} details={!isSmallScreen && details} />
                    )}
                </span>
            </Tooltip>
            {!isSmallScreen && (
                <span className="saving-status__ghost" aria-hidden="true">
                    <Line label="Saved to Board" details={details} />
                </span>
            )}
        </div>
    );
};

export default SavingStatus;
